import { Tooltip, TextField, Box, FormControl, FormControlLabel, Grid, Button, Radio, RadioGroup, Select, Stack, InputAdornment } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import IdentidadEjemplo from '../IdentidadEjemplo.jpg'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import classes from "../ParticipanteClasess.css";
import { useState } from "react";
import Desplegable from "./Desplegable";
import Autocomplete from '@mui/material/Autocomplete';
import * as React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español

function CustomDatePicker(props) {
    const today = dayjs();
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [invalidFormat, setInvalidFormat] = React.useState(false);

    const handleDateChange = (date) => {
        if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
            setInvalidFormat(true);
        } else {
            setInvalidFormat(false);
            setSelectedDate(date);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                id='aval1Nacimiento'
                format={"DD/MM/YYYY"}
                value={selectedDate}
                onChange={handleDateChange}
                slotProps={{
                    textField: {
                        helperText: invalidFormat ? "Formato de fecha incorrecto" : (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                        onChange: { onchange }
                    },
                }}
                maxDate={today}
                {...props}
            />
        </LocalizationProvider>
    );
}

export default function Aval({ errorsEnviar, setErrors, formulario, onchange, Datepickernacimiento, handleblurAval, handletipovivienda, valorvivienda, selectedcivil, handlecivil,
    selecteddepa, handledepa, selecteddepalaboral, handledepalaboral
}) {

    const [civil, setCivil] = useState('');
    const [selectedIdentidadAval1, setselectedIdentidadAval1] = useState(null);

    const handleDragOverIdentidadSoli = (event) => {
        event.preventDefault();
    };

    const handleDropIdentidadSoli = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval1(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleClickIdentidadSoli = () => {
        document.getElementById('selectedIdentidadSoli').click();
    };

    const handleFileChangeIdentidadSoli = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval1(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleChange = (event) => {
        setCivil(event.target.value);
    };

    const defaultProps = {
        options: listadepartamentos,
        getOptionLabel: (option) => option.title,
    };
    const flatProps = {
        options: listadepartamentos.map((option) => option.title),
    };

    const defaultPropsCivil = {
        options: listacivil,
        getOptionLabel: (option) => option.title,
    };
    const flatPropsCivil = {
        options: listacivil.map((option) => option.title),
    };


    const [value, setValue] = React.useState(null);

    const validarSoloNumeros = (event) => {
        // Solo permitir números
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
    };

    const validarSoloLetras = (event) => {
        // Solo permitir letras y espacio
        event.target.value = event.target.value.replace(/[^A-Za-z\s]/g, '');
    };


    /*---------------------FINAL Validación Longitudes Y Campos Vacíos* ---------------*/

    return (
        <>
            <Stack direction="column" style={{ display: 'flex', alignItems: 'center', alignContent: 'center' }} >
                <h3 >IV. DATOS PERSONALES - AVAL 1</h3>
            </Stack>

            <Stack direction="column" spacing={2}>
                <TextField id="aval1Identidad" placeholder="Ingrese # de identidad" label="Numero de Identidad" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 13 }}
                    value={formulario.aval1Identidad}
                    onChange={onchange}
                    error={Boolean(errorsEnviar.aval1Identidad)}
                    onBlur={handleblurAval}
                    helperText={errorsEnviar.aval1Identidad} />
                <TextField id="aval1Nombres" placeholder="Ingrese el nombre" label="Nombres" variant="outlined" onInput={validarSoloLetras}
                    value={formulario.aval1Nombres}
                    onChange={onchange}
                    error={Boolean(errorsEnviar.aval1Nombres)}
                    onBlur={handleblurAval}
                    helperText={errorsEnviar.aval1Nombres} />
                <TextField id="aval1Apellidos" placeholder="Ingrese los apellidos" label="Apellidos" variant="outlined" onInput={validarSoloLetras}
                    value={formulario.aval1Apellidos}
                    onChange={onchange}
                    error={Boolean(errorsEnviar.aval1Apellidos)}
                    onBlur={handleblurAval}
                    helperText={errorsEnviar.aval1Apellidos} />
                <Datepickernacimiento label="Fecha Nacimiento" id="aval1nacimiento" />
                <TextField id="aval1Profesion" placeholder="Ingrese profesión u oficio" label="Profesión u Oficio" variant="outlined" onInput={validarSoloLetras}
                    value={formulario.aval1Profesion}
                    onChange={onchange}
                    error={Boolean(errorsEnviar.aval1Profesion)}
                    onBlur={handleblurAval}
                    helperText={errorsEnviar.aval1Profesion} />
            </Stack>


            <Stack className={classes.above} direction="row" >
                <Grid spacing={2} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Box >
                        <FormControl  >
                            <Stack direction="column" marginTop={4} style={{ textAlign: 'center' }}>
                                {<label><strong>Tipo De Vivienda</strong></label>}
                            </Stack>
                            <RadioGroup row aria-labelledby="Tipo Vivienda" name="tipoVivienda" id="tipoViviendaAval1"
                                onChange={handletipovivienda} value={valorvivienda}>
                                <FormControlLabel value="aval1vivienda1" control={<Radio color="error" />} label="Propia" />
                                <FormControlLabel value="aval1vivienda2" control={<Radio color="error" />} label="Familiar" />
                                <FormControlLabel value="aval1vivienda3" control={<Radio color="error" />} label="Alquilada" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Grid>
            </Stack>

            <Stack className={classes.above} direction="column" marginTop={2}>
                <Grid Container>

                    <Box>
                        <label><strong>Dirección</strong></label>
                        <Stack direction="column" spacing={2}>
                            <TextField id="aval1Barrio" placeholder="Ingrese barrio o colonia" label="Barrio/Col." variant="outlined"
                                value={formulario.aval1Barrio}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1Barrio)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1Barrio} />

                            <TextField id="aval1Ave" placeholder="Ingrese avenida" label="Ave." variant="outlined"
                                value={formulario.aval1Ave}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1Ave)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1Ave} />

                            <TextField id="aval1Calle" placeholder="Ingrese # calle" label="Calle." variant="outlined"
                                value={formulario.aval1Calle}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1Calle)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1Calle} />

                            <TextField id="aval1Casa" placeholder="Ingrese # casa" label="Casa No." variant="outlined"
                                value={formulario.aval1Casa}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1Casa)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1Casa} />

                            <TextField id="aval1Ciudad" placeholder="Ingrese la ciudad" label="Ciudad" variant="outlined"
                                value={formulario.aval1Ciudad}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1Ciudad)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1Ciudad} />

                            <Autocomplete
                                {...defaultProps}
                                id="aval1Departamento"
                                value={selecteddepa}
                                onChange={handledepa}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder="Ingrese el departamento" label="Departamento" variant="outlined"
                                        error={Boolean(errorsEnviar.aval1Departamento)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval1Departamento} />
                                )}
                            />

                            <Autocomplete
                                {...defaultPropsCivil}
                                id="estadocivilAval1"
                                value={selectedcivil}
                                onChange={handlecivil}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder="Ingrese estado civil" label="Estado Civil" variant="outlined"
                                        error={Boolean(errorsEnviar.estadocivilAval1)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.estadocivilAval1} />
                                )}
                            />

                            <TextField id="aval1ReferenciaDomicilio" placeholder="Ingrese referencia del domicilio" label="Referencia Domicilio" variant="outlined"
                                value={formulario.aval1ReferenciaDomicilio}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1ReferenciaDomicilio)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1ReferenciaDomicilio} />

                            <TextField id="aval1Fijo" label="Teléfono Fijo" placeholder="Ingrese # de teléfono fijo" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                value={formulario.aval1Fijo}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1Fijo)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1Fijo} />

                            <TextField id="aval1Movil" label="Teléfono Movil" placeholder="Ingrese # de teléfono móvil" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                value={formulario.aval1Movil}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1Movil)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1Movil} />
                            <TextField id="aval1Correo" label="Correo Electrónico" placeholder="Ingrese correo electrónico" variant="outlined"
                                value={formulario.aval1Correo}
                                onChange={onchange}
                                error={Boolean(errorsEnviar.aval1Correo)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval1Correo} />
                        </Stack>
                    </Box>
                </Grid>
            </Stack>

            <Box>
                <Stack direction="column" style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                    <h3 >V. INFORMACIÓN LABORAL - AVAL 1</h3>
                </Stack>

                <Stack direction="column" spacing={2}>
                    <TextField id="aval1Dependencia" placeholder="Ingrese dependencia laboral" label="Dependencia donde trabaja" variant="outlined"
                        value={formulario.aval1Dependencia}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval1Dependencia)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval1Dependencia} />

                    <TextField id="aval1Ramo" placeholder="Ingrese ramo" label="Ramo" variant="outlined"
                        value={formulario.aval1Ramo}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval1Ramo)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval1Ramo} />

                    <TextField id="aval1TelefonoTrabajo" placeholder="Ingrese # teléfono" label="Teléfono" variant="outlined" inputProps={{ maxLength: 8 }} onInput={validarSoloNumeros}
                        value={formulario.aval1TelefonoTrabajo}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval1TelefonoTrabajo)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval1TelefonoTrabajo} />

                    <Box marginTop={2}>
                        <label><strong>Dirección</strong></label>
                        <Box>
                            <Stack direction="column" spacing={2}>
                                <TextField id="aval1BarrioTrabajo" placeholder="Ingrese barrio/colonia" label="Barrio/Col." variant="outlined"
                                    value={formulario.aval1BarrioTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval1BarrioTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval1BarrioTrabajo} />

                                <TextField id="aval1AveTrabajo" placeholder="Ingrese avenida" label="Ave." variant="outlined"
                                    value={formulario.aval1AveTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval1AveTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval1AveTrabajo} />

                                <TextField id="aval1CalleTrabajo" placeholder="Ingrese # de calle" label="Calle" variant="outlined"
                                    value={formulario.aval1CalleTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval1CalleTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval1CalleTrabajo} />

                                <TextField id="aval1CasaTrabajo" placeholder="Ingrese # de casa" label="Casa No." variant="outlined"
                                    value={formulario.aval1CasaTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval1CasaTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval1CasaTrabajo} />

                                <TextField id="aval1CiudadTrabajo" placeholder="Ingrese ciudad" label="Ciudad" variant="outlined"
                                    value={formulario.aval1CiudadTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval1CiudadTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval1CiudadTrabajo} />

                                <Autocomplete
                                    {...defaultProps}
                                    id="aval1Departamentotrabajo"
                                    value={selecteddepalaboral}
                                    onChange={handledepalaboral}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Ingrese el departamento" label="Departamento" variant="outlined"
                                            error={Boolean(errorsEnviar.aval1Departamentotrabajo)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval1Departamentotrabajo} />
                                    )}
                                />
                            </Stack>
                        </Box>
                    </Box>

                    <TextField id="sueldoMensualAval1" placeholder="Sueldo Mensual" label="Sueldo Mensual" onInput={validarSoloNumeros} variant="outlined"
                        value={formulario.sueldoMensualAval1}
                        onChange={onchange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    L.
                                </InputAdornment>
                            ),
                        }}
                        error={Boolean(errorsEnviar.sueldoMensualAval1)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.sueldoMensualAval1} />

                    <TextField id="otrosIngresosAval1" placeholder="Otros Ingresos" label="Otros ingresos (detalle)" onInput={validarSoloNumeros} variant="outlined"
                        value={formulario.otrosIngresosAval1}
                        onChange={onchange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    L.
                                </InputAdornment>
                            ),
                        }}
                        error={Boolean(errorsEnviar.otrosIngresosAval1)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.otrosIngresosAval1} />

                    <TextField id="sueldoNetoAval1" label="Sueldo Neto" placeholder="Sueldo Neto" onInput={validarSoloNumeros} variant="outlined"
                        value={formulario.sueldoNetoAval1}
                        onChange={onchange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    L.
                                </InputAdornment>
                            ),
                        }}
                        error={Boolean(errorsEnviar.sueldoNetoAval1)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.sueldoNetoAval1} />

                    <TextField id="aval1Puesto" placeholder="Ingrese el puesto" label="Puesto" variant="outlined"
                        value={formulario.aval1Puesto}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval1Puesto)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval1Puesto} />

                    <Box marginTop={2}>
                        <label><strong>Tiempo De Laborar</strong></label>
                    </Box>
                    <TextField id="aval1Years" label="Años" variant="outlined" placeholder="Años"
                        value={formulario.aval1Years}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval1Years)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval1Years} />

                    <TextField id="aval1Meses" label="Meses" variant="outlined" placeholder="Meses"
                        value={formulario.aval1Meses}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval1Meses)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval1Meses} />
                </Stack>
            </Box>

            <Box marginTop={5}>
                <Stack direction="column" style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                    <h3 >COPIA DE LA IDENTIDAD DEL AVAL 1 EN FORMATO PDF</h3>
                </Stack>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onDragOver={handleDragOverIdentidadSoli}
                    onDrop={handleDropIdentidadSoli}
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: '300px',
                            textAlign: 'center',
                            borderColor: selectedIdentidadAval1 ? 'green' : '#a0a0a0',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <Tooltip
                            title={
                                <div style={{ textAlign: 'center' }}>
                                    <p style={{ fontSize: 15, textAlign: 'justify' }}>El archivo pdf debe contener la tarjeta de identidad por ambos lados de la siguiente forma:</p>
                                    <img src={IdentidadEjemplo} alt="Identidad Ejemplo" style={{ width: '200px', height: 'auto' }} />
                                </div>
                            }
                            interactive
                        >
                            <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                        </Tooltip>
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleClickIdentidadSoli}
                            color="primary"
                            style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                        >
                            Seleccionar Identidad En PDF
                        </Button>
                        <input
                            id="selectedIdentidadAval1"
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChangeIdentidadSoli}
                        />
                        {!selectedIdentidadAval1 && <p>Seleccione el archivo PDF</p>}
                        {selectedIdentidadAval1 && <p>Archivo seleccionado: {selectedIdentidadAval1.name}</p>}
                    </Box>
                </Box>
            </Box>
        </>
    );
}

const listadepartamentos = [
    { title: 'Atlantida', },
    { title: 'Colón', },
    { title: 'Comayagua', },
    { title: 'Copán', },
    { title: 'Cortés', },
    { title: 'Choluteca', },
    { title: 'El Paraíso', },
    { title: 'Francisco Morazán', },
    { title: 'Gracias A Dios', },
    { title: 'Intibucá', },
    { title: 'Islas De La Bahía', },
    { title: 'La Paz', },
    { title: 'Lempira', },
    { title: 'Ocotepeque', },
    { title: 'Olancho', },
    { title: 'Santa Bárbara', },
    { title: 'Valle', },
    { title: 'Yoro', },
];

const listacivil = [
    { title: 'Soltero', },
    { title: 'Casado', },
    { title: 'Viudo', },
    { title: 'Divorciado', },
    { title: 'Unión Libre', },
];

const listabancos = [
    { title: 'Banco Atlántida S.A.', },
    { title: 'Banco de Occidente S.A.', },
    { title: 'Banco de Los Trabajadores', },
    { title: 'Banco Financiera Centroamericana S.A. (FICENSA)', },
    { title: 'Banco Hondureño del Café S.A. (BANHCAFE)', },
    { title: 'Banco del País S.A. (BANPAIS)', },
    { title: 'Banco Financiera Comercial Hondureña S.A. (FICOHSA)', },
    { title: 'Banco Lafise Honduras  S.A.', },
    { title: 'Banco Davivienda Honduras S.A.', },
    { title: 'Banco Promérica S.A.', },
    { title: 'Banco de Desarrollo Rural Honduras S.A.', },
    { title: 'Banco Azteca de Honduras S.A.', },
    { title: 'Banco Popular S.A.', },
    { title: 'Banco de América Central Honduras S.A. (BAC) | Honduras', },
    { title: 'Banco de Honduras (Citi Honduras)', },
    { title: 'Banco Nacional de Desarrollo Agrícola (BANADESA)', },
    { title: 'Banco Hondureño para la Producción y la Vivienda (BANHPROVI)', },
];
